export function getType() {
    return (typeof window.resemPage !== "undefined") ? window.resemPage.type : "";
}

export function getOperation() {
    return (typeof window.resemPage !== "undefined") ? window.resemPage.operation : "";
}

